import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

const aiActions = defineAIActions({
  namespace: 'schedule',
  actions: [
    {
      id: 'suggest-time',
      name: '推荐发布时间',
      description: '根据历史数据推荐最佳发布时间',
      parameters: [
        { name: 'accountId', type: 'number', description: '账号ID', required: false },
      ],
      handler: async (params) => {
        const times = ['08:00', '12:00', '18:00', '21:00'];
        return {
          type: 'table',
          data: times.map(t => ({ time: t, reason: '该时段用户活跃度高' })),
          message: '推荐了4个最佳发布时间段',
        };
      },
    },
    {
      id: 'batch-schedule',
      name: '批量排期',
      description: '智能批量安排发布计划',
      parameters: [
        { name: 'contentIds', type: 'array', description: '内容ID列表', required: true },
        { name: 'startDate', type: 'string', description: '开始日期', required: true },
      ],
      handler: async (params) => {
        return {
          type: 'action',
          data: { scheduled: params.contentIds?.length || 0 },
          message: `已为 ${params.contentIds?.length || 0} 篇内容安排发布计划`,
        };
      },
    },
  ],
});

export default definePlugin({
  meta: {
    name: 'scheduler',
    version: '1.0.0',
    displayName: '排期调度',
    description: '内容排期、定时发布、发布队列管理',
    icon: 'calendar',
    category: 'operations',
  },

  onLoad: async () => {
    console.log('[Plugin] Scheduler loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Scheduler unloaded');
  },

  routes: [
    {
      path: '/schedule',
      lazy: async () => {
        const { ScheduleCalendar } = await import('./pages/ScheduleCalendar');
        return { Component: ScheduleCalendar };
      },
    },
    {
      path: '/schedule/queue',
      lazy: async () => {
        const { PublishQueue } = await import('./pages/PublishQueue');
        return { Component: PublishQueue };
      },
    },
    {
      path: '/schedule/history',
      lazy: async () => {
        const { PublishHistory } = await import('./pages/PublishHistory');
        return { Component: PublishHistory };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'schedule',
      title: '排期调度',
      icon: 'calendar',
      path: '/schedule',
      order: 7,
    },
  ],

  aiActions,
});

